import SchemaField from "./SchemaField";

import ArrayField from "./ArrayField";
import BooleanField from "./BooleanField";
import DescriptionField from "./DescriptionField";
import MultiSchemaField from "./MultiSchemaField";
import NumberField from "./NumberField";
import ObjectField from "./ObjectField";
import StringField from "./StringField";
import TitleField from "./TitleField";
import UnsupportedField from "./UnsupportedField";

// extra

//import ColorString from "./ColorString";
//import LocalizedString from "./LocalizedString";
//import GeopointObject from "./GeopointObject";
//import MediaObject from "./MediaObject";
//import ReferenceObject from "./ReferenceObject";

export default {
    AnyOfField: MultiSchemaField,
    ArrayField: ArrayField,
    BooleanField: BooleanField,
    DescriptionField: DescriptionField,
    NumberField: NumberField,
    ObjectField: ObjectField,
    OneOfField: MultiSchemaField,
    SchemaField: SchemaField,
    StringField: StringField,
    TitleField: TitleField,
    UnsupportedField: UnsupportedField
    //    "color": ColorString,
    //    "localizedString": LocalizedString,
    //    "geopoint": GeopointObject,
    //    "media": MediaObject,
    //    "reference": ReferenceObject
};